import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChair"><Path fillRule="evenodd" clipRule="evenodd" d="M5 11V2H19V11H16.5V13H20V14.5H19V22H17.5V18.75H6.5V22H5V14.5H4V13H7.5V11H5ZM9 11V13H15V11H9ZM17.5 14.5V17.25H6.5V14.5H17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChair;
